import React from 'react';
import {Helmet} from 'react-helmet';
import {graphql} from 'gatsby';
import Hero from '../components/Hero/Hero';

const IndexPage = ({pageContext, data}) => {
    const {content, languages} = JSON.parse(data.sheets.jsonPayload);

    const _headerData = JSON.parse(data.header.data);
    const headerData = Object.assign({}, _headerData, {
        withoutLogin: Boolean(true),
    });
    const footerData = JSON.parse(data.footer.data);
    const countryCode = headerData.flags
        ? headerData.flags.items[0].countryCode
        : 'us';
    const countryCodes = footerData.smsWidget
        ? footerData.smsWidget.countryCodes
        : {};

    return (
        <div className="main" context={pageContext}>
            <Helmet>
                <title>{content.meta.title}</title>
            </Helmet>
            <Hero
                {...content}
                {...languages}
                countryCode={countryCode}
                countryCodes={countryCodes}
            />
        </div>
    );
};

export default IndexPage;

export const ContentQuery = graphql`
    query {
        header {
            data
        }
        footer {
            data
        }
        sheets {
            jsonPayload
        }
    }
`;
